<template>
  <v-container class="pt-7">
    <v-layout row no-gutters justify-space-between wrap class="pa-3">
      <v-flex class="pr-4" lg8 sm8>
        <h1 class="mb-5">{{ $t('welcome.title') }}</h1>
        <p class="mb-6">{{ $t('welcome.text1') }}</p>
        <p class="mb-6 pr-sm-4">{{ $t('welcome.text2') }}</p>

        <div class="link-inline mb-9 pb-4">
          {{ $t('textNoCMD[0]') }}
          <a
            id="cmd-request"
            target="_blank"
            href="https://www.autenticacao.gov.pt/cmd-pedido-chave"
            @click.stop
          >
            {{ $t('textNoCMD[1]') }}
            <img src="@/assets/link.svg" class="Shape" />.
          </a>
        </div>
        <v-checkbox
          v-if="!(ERROR_CODE === '504' || ERROR_CODE === '505')"
          id="terms"
          v-model="terms"
          color="#009fb1"
          class="terms-checkbox"
        >
          <div slot="label">
            {{ $t('welcome.terms[0]') }}
            <a
              id="cmd-terms"
              slot="activator"
              target="_blank"
              href="https://www.autenticacao.gov.pt/web/guest/termos-e-condicoes"
              @click.stop
            >
              {{ $t('welcome.terms[1]') }}
              <img src="@/assets/link.svg" class="Shape" />
            </a>
            <!-- {{ $t('welcome.terms[2]') }}
            <a
              id="wallid-terms"
              slot="activator"
              target="_blank"
              href="https://wallidtsp.io/termsiframe"
              @click.stop
            >
              {{ $t('welcome.terms[3]') }}
              <img src="@/assets/link.svg" class="Shape" />.
            </a> -->
          </div>
        </v-checkbox>
      </v-flex>
      <!-- <v-flex v-show="loading" lg4 >
          <p class="Please-wait" style="text-align:center;">{{$t('loader')}}</p>
          <div class="half-circle-spinner">
            <div class="circle circle-1"></div>
            <div class="circle circle-2"></div>
          </div>
        </v-flex>
        -->
      <v-flex class="welcome-image d-none d-sm-flex" lg4 sm4>
        <v-img contain src="@/assets/welcome-qes.png" />
      </v-flex>
    </v-layout>
    <v-footer fixed class="iframe-footer">
      <v-container grid-list-md text-center>
        <v-layout justify-end>
          <v-btn
            id="advance-btn"
            :disabled="isDisabled"
            depressed
            @click="submitStep"
            class="advance button-iframe"
            >{{ $t('button.next') }}</v-btn
          >
        </v-layout>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import mixinQES from './mixinQES';

import { mapGetters } from 'vuex';
export default {
  name: 'Welcome',
  mixins: [mixinQES],
  watch: {
    terms(val) {
      if (val) {
        this.$gtag.event('accept_terms', {
          event_category: 'qes',
          event_label: 'qes_terms',
        });
      }
    },
  },
  created() {
    if (window.ERROR_CODE == '504') {
      console.log(window.ERROR_CODE, this.$t('errors.notPDF'));

      const fileNames = window.ERROR_MESSAGE.replaceAll(';', ', ').slice(0, -2);
      this.$store.commit(
        'errorMsg',
        `${fileNames} ${this.$t('errors.notPDF')}`
      );
    }

    if (window.ERROR_CODE == '505') {
      console.log(window.ERROR_CODE, this.$t('errors.alreadySigned'));
      this.$store.commit('errorMsg', 'alreadySigned');
    }
  },
  methods: {
    async submitStep() {
      console.log('Submit Step', this.step);

      this.$gtag.event('welcome_next', {
        event_category: 'qes',
        event_label: 'qes_welcome_next',
      });

      const { wallid } = window; //{ wallid: false }; //window;
      let UC_CMD_PT;
      if (wallid) {
        let isOnboardingComplete = (
          await wallid('wallid_onboarding').catch((err) => {
            return err;
          })
        )?.initialized;
        if (isOnboardingComplete) {
          await wallid('wallid_connect', { level: 2 });
        }
        const storedIds = await wallid('wallid_identities').catch((err) => {
          console.log(err);
          return [];
        });
        console.log(storedIds);
        UC_CMD_PT = storedIds.find((data) => data.idt === 'UC_CMD_PT');
      }
      if (UC_CMD_PT) {
        this.$store.commit('qes/hasIdentities', true);

        await this.getUserCredentialsCMD();

        // this.$router.push({ name: this.ROUTE_SUCCESS }); // debug
        this.$router.push({
          name: this.BASE_ROUTE + this.ROUTE_SIGNATURE_SINGLE_STEP,
        });
        // this.$router.push({ name: this.ROUTE_SIGNATURE_PROCESS }); // debug
      } else {
        this.step = 1;
        // this.$router.push({ name: this.ROUTE_SUCCESS }); // debug
        this.$router.push({
          name: this.BASE_ROUTE + this.ROUTE_SIGNATURE_PROCESS,
        });
      }
      this.$store.commit('errorMsg');
    },

    async getUserCredentialsCMD() {
      // Check if plugin is installed

      const { wallid } = window;

      if (wallid) {
        const CMD_ID = await wallid('wallid_export_asset', [
          'identities',
          'UC_CMD_PT',
        ]);
        console.log('Id from plugin: ', CMD_ID);

        // TO DO : Call decrypt

        if (CMD_ID) {
          this.$store.commit('qes/mobileNumber', CMD_ID.data?.telephone);
          this.$store.commit(
            'qes/mobileNumberEncrypted',
            CMD_ID.data?.telephoneEncrypted
          );
          this.$store.commit('qes/pinEncrypted', CMD_ID.data?.pinEncrypted);
          // this.mobileNumber = dataParsed.telephone;
          // this.mobileNumberEncrypted = dataParsed.telephoneEncrypted;
          // this.pinEncrypted = dataParsed.pinEncrypted;

          // Send request when mounted
        }
      }
    },
  },
  computed: {
    ...mapGetters(['loading', 'errorMsg']),
    ERROR_CODE() {
      return window.ERROR_CODE;
    },
    step: {
      get() {
        return this.$store.state.qes.step;
      },
      set(newValue) {
        return this.$store.commit('qes/step', newValue);
      },
    },
    isDisabled() {
      return (
        this.loading ||
        !this.terms ||
        window.ERROR_CODE === '504' ||
        window.ERROR_CODE === '505'
      );
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    terms: {
      get() {
        return this.$store.state.terms;
      },
      set(value) {
        this.$store.commit('terms', value);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@keyframes loading {
  100% {
    transform: translateX(100%);
  }
}
.skeleton-loader {
  .header,
  p,
  h2,
  .container {
    background-color: #eeeeee;
  }
  .header::after {
    -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 70px;
    transform: translateX(-100%);
    z-index: 1;
    background: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 100%, 0.4),
      hsla(0, 0%, 100%, 0)
    );
  }
  h2 {
    max-width: 533px;
    height: 19px;
    border-radius: 12px;
    margin-bottom: 29px;
  }
  p {
    max-width: 533px;
    height: 19px;
    border-radius: 12px;
    margin-bottom: 7px;
  }
  .header {
    max-width: 267px;
    height: 30px;
    border-radius: 18px;
  }
  .container {
    border-radius: 50%;
    width: 214px;
    height: 214px;
  }
}

.cancel {
  height: 36px;
  margin: 0px;
  border-radius: 2px;

  margin-right: 632px;
  margin-left: 24px;
  color: #035b60;
}
.bottom {
  margin-top: 12px;
  margin-bottom: 12px;
}

.line {
  margin-top: 50px;
  margin-bottom: 11px;
}
</style>
